var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-darkblue-400 h-px w-full"})}
var staticRenderFns = []

export { render, staticRenderFns }